export enum Role {
  CALLCENTER = 'CCC',
  MARKETING = 'MKT'
}
